/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Featured_DayInputs */

const en_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} day`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} days`);
	return /** @type {LocalizedString} */ (`${i?.number} days`)
	
};

const ar_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`${i?.number} يوم`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} يوم`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`${i?.number} يومان`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} أيام`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} يومًا`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} يوم`);
	return /** @type {LocalizedString} */ (`${i?.number} يوم`)
	
};

const de_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} Tag`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} Tage`);
	return /** @type {LocalizedString} */ (`${i?.number} Tage`)
	
};

const es_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} día`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} días`);
	return /** @type {LocalizedString} */ (`${i?.number} días`)
	
};

const fr_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} jour`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} jours`);
	return /** @type {LocalizedString} */ (`${i?.number} jours`)
	
};

const it_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} giorno`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} giorni`);
	return /** @type {LocalizedString} */ (`${i?.number} giorni`)
	
};

const ja_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}日`);
	return /** @type {LocalizedString} */ (`${i?.number}日`)
	
};

const ko_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}일`);
	return /** @type {LocalizedString} */ (`${i?.number}일`)
	
};

const pt_br_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} dia`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} dias`);
	return /** @type {LocalizedString} */ (`${i?.number} dias`)
	
};

const ru_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} день`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} дня`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} дней`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} дня`);
	return /** @type {LocalizedString} */ (`${i?.number} дня`)
	
};

const th_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} วัน`);
	return /** @type {LocalizedString} */ (`${i?.number} วัน`)
	
};

const tr_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} gün`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} gün`);
	return /** @type {LocalizedString} */ (`${i?.number} gün`)
	
};

const zh_cn_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 天`);
	return /** @type {LocalizedString} */ (`${i?.number} 天`)
	
};

const zh_tw_featured_day = /** @type {(inputs: Featured_DayInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 天`);
	return /** @type {LocalizedString} */ (`${i?.number} 天`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "{number} day" |
* | "other" | "{number} days" |
* | * | "{number} days" |
*
* @param {Featured_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const featured_day = /** @type {((inputs: Featured_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_day(inputs)
	if (locale === "ar") return ar_featured_day(inputs)
	if (locale === "de") return de_featured_day(inputs)
	if (locale === "es") return es_featured_day(inputs)
	if (locale === "fr") return fr_featured_day(inputs)
	if (locale === "it") return it_featured_day(inputs)
	if (locale === "ja") return ja_featured_day(inputs)
	if (locale === "ko") return ko_featured_day(inputs)
	if (locale === "pt_br") return pt_br_featured_day(inputs)
	if (locale === "ru") return ru_featured_day(inputs)
	if (locale === "th") return th_featured_day(inputs)
	if (locale === "tr") return tr_featured_day(inputs)
	if (locale === "zh_cn") return zh_cn_featured_day(inputs)
	return zh_tw_featured_day(inputs)
});